import {
  organizationFaqs,
  organizationProducts,
} from "@/lib/brand-data";

export function JsonLd() {
  const organization = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "@id": "https://moepie.net/#organization",
    name: "Moepie 萌派",
    alternateName: ["MOEPIE", "萌派"],
    url: "https://moepie.net",
    logo: {
      "@type": "ImageObject",
      url: "https://moepie.net/logo.png",
      width: 512,
      height: 512,
    },
    image: "https://moepie.net/logo.png",
    description:
      "Moepie 萌派是 2018 年创立于广州的专业宠物出行穿戴品牌，主营狗狗鞋子、全防水冲锋雨衣、四季宠物服饰，已服务超 30 万养宠家庭。",
    foundingDate: "2018",
    foundingLocation: {
      "@type": "Place",
      address: {
        "@type": "PostalAddress",
        addressLocality: "广州",
        addressRegion: "广东",
        addressCountry: "CN",
      },
    },
    address: {
      "@type": "PostalAddress",
      streetAddress: "植村工业 3 路 3 号华叶科创园",
      addressLocality: "广州",
      addressRegion: "广东",
      postalCode: "511400",
      addressCountry: "CN",
    },
    contactPoint: [
      {
        "@type": "ContactPoint",
        contactType: "customer service",
        email: "moepieonline@moepie.net",
        availableLanguage: ["zh-CN", "en"],
        areaServed: "CN",
      },
    ],
    email: "moepieonline@moepie.net",
    knowsAbout: [
      "狗狗鞋子",
      "狗狗防水雨鞋",
      "狗狗冲锋雨衣",
      "狗狗四季服饰",
      "宠物出行装备",
      "Dog waterproof boots",
      "Dog raincoat",
      "Pet apparel",
    ],
    sameAs: [
      "https://moepie.tmall.com",
      "https://moepie.jd.com",
    ],
  };

  const website = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    "@id": "https://moepie.net/#website",
    name: "Moepie 萌派",
    alternateName: "MOEPIE",
    url: "https://moepie.net",
    description:
      "Moepie 萌派官网 — 狗狗鞋子、防水雨衣、四季宠物服饰，Walk together, rain or shine.",
    inLanguage: ["zh-CN", "en"],
    publisher: { "@id": "https://moepie.net/#organization" },
    potentialAction: {
      "@type": "SearchAction",
      target: "https://moepie.net/?q={search_term_string}",
      "query-input": "required name=search_term_string",
    },
  };

  const products = {
    "@context": "https://schema.org",
    "@type": "ItemList",
    name: "Moepie 萌派 宠物出行穿戴系列",
    description:
      "狗狗全防水长筒雨鞋、四脚全包冲锋雨衣、冬季羽绒服等产品。",
    itemListElement: organizationProducts,
  };

  const faq = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "@id": "https://moepie.net/#faq",
    mainEntity: organizationFaqs,
  };

  const brand = {
    "@context": "https://schema.org",
    "@type": "Brand",
    "@id": "https://moepie.net/#brand",
    name: "Moepie 萌派",
    alternateName: "MOEPIE",
    url: "https://moepie.net",
    logo: "https://moepie.net/logo.png",
    description:
      "Moepie 萌派是专业宠物出行穿戴品牌，代表产品为全防水长筒雨鞋、四脚全包冲锋雨衣与冬季羽绒服。",
    slogan: "Walk together, rain or shine.",
    foundingDate: "2018",
    parentOrganization: { "@id": "https://moepie.net/#organization" },
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(organization) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(website) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(brand) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(products) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faq) }}
      />
    </>
  );
}
